module.exports = __webpack_public_path__ + "static/media/member-2.d475dae1.png";


//////////////////
// WEBPACK FOOTER
// ./src/routes/Team/assets/member-2.png
// module id = 1095
// module chunks = 0